import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { map, tap } from 'rxjs/operators';
import { RoutesService } from '../../../../../../shared/services/routes/routes.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { ProfessionalStyle } from '@adeo/ngx-kozikaza-api';
import { ProfessionalServiceType } from '@adeo/ngx-kozikaza-api/pro/service';
import { ActivatedRoute, Router } from '@angular/router';
import { decoOffersSlug } from '../../../professional-routing.module';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';
import { KzIconsRegistryService } from '../../../../../../kz-ui/ui/icon/kz-icons-registry.service';
import { kzIconsArrowleft } from '../../../../../../kz-ui/ui/icon/generated-icons/kzIcons-arrowleft.icon';
import { SeoService } from "../../../../../../shared/services/utilities/seo.service";

@Component({
  selector: 'app-pro-listing-header',
  templateUrl: './pro-listing-header.component.html',
  styleUrls: ['./pro-listing-header.component.scss']
})
export class ProListingHeaderComponent implements OnInit, OnDestroy {
  private activatedRouteSubscription: Subscription;
  public style: ProfessionalStyle;
  public type: ProfessionalServiceType;
  public city: any;
  public alt: string;

  @Input() bannerType: 'pro' | 'pro-box' = 'pro';
  @Input() listingType: 'pros' | 'pro-services' = 'pros';
  @Input() jobType?: string = null;

  public prosRoute: Array<string>;
  public proServicesRoute: Array<string>;
  public noBoxRoute: Array<string>;

  constructor(
    private routesService: RoutesService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private readonly localizeRouterService: LocalizeRouterService,
    private readonly translateService: TranslateService,
    private readonly kzIconsRegistryService: KzIconsRegistryService,
    private readonly seoService: SeoService,
  ) {
    this.kzIconsRegistryService.registerIcons([kzIconsArrowleft]);
    this.seoService.preloadFont("Roboto");
  }

  ngOnInit(): void {
    this.prosRoute = this.localizeRouterService.translateRoute(['/', 'pro', ...(this.bannerType === 'pro-box' ? ['box'] : [] )]) as string[];
    this.proServicesRoute = this.localizeRouterService.translateRoute(['/', 'pro', decoOffersSlug, ...(this.bannerType === 'pro-box' ? ['box'] : [] )])as string[];
    this.alt = (this.listingType === 'pros')
      ? $localize`:@@pro.listing.header.pro.alt:Directory of interior designers`
      : $localize`:@@pro.listing.header.proBox.alt:Decoration offers directory`;
    // 'Annuaire des décorateurs d\'intérieur' <> 'Annuaire des offres décoration'
    this.activatedRouteSubscription = this.routesService.eventNavigationEnd.pipe(
      map(() => this.activatedRoute.snapshot),
      tap((route: any) => {
        const urlTree = this.router.parseUrl(this.router.url);
        const urlSegments = urlTree.root.children.primary.segments;
        this.noBoxRoute = ['/', ...(urlSegments.map(it => it.path).filter((seg) => seg !== this.translateService.instant('routes.box')))];
        this.style = ((route.parent.parent.data && route.parent.parent.data.style) ? route.parent.parent.data.style: null);
        this.type = ((route.parent.parent.data && route.parent.parent.data.serviceType) ? route.parent.parent.data.serviceType: null);
        this.city = ((route.parent.parent.params && route.parent.parent.params.city) ? route.parent.parent.params.city: null);
      })
    ).subscribe();
  }

  ngOnDestroy() {
    if (this.activatedRouteSubscription && !this.activatedRouteSubscription.closed) {
      this.activatedRouteSubscription.unsubscribe();
    }
  }

}
